import Panel from './Panel.js';

/**
 * Panel Class.
 */
export default class PanelVariants extends Panel {
  static config = {
    name: 'PanelVariants',
    refs: [...Panel.config.refs],
  };

  /**
   *
   */
  mounted() {
    this.fromAddToCart = false;
    super.mounted();
  }

  /**
   * Open Panel
   * @param {boolean} fromAddToCart origin of open panel
   */
  openPanel(fromAddToCart) {
    this.fromAddToCart = fromAddToCart;
    this.isOpen = true;
    document.body.classList.add('overflow-hidden');
    this.header.classList.remove('z-40');
    this.header.classList.add('z-10');
    this.$el.classList.remove('hidden');

    setTimeout(() => {
      this.$el.classList.remove('pointer-events-none');
      this.$refs.overlay.classList.remove('opacity-0');
      this.$refs.panel.classList.remove('translate-x-full', 'pointer-events-none');
    }, 200);
  }

  /**
   * Close popin
   * @returns {void}
   */
  closePanel() {
    const anyChecked = !!this.$el.querySelector('input[type="radio"]:not(.disabled):checked');
    this.isOpen = false;
    this.$emit('close-panel');
    document.body.classList.remove('overflow-hidden');
    this.$refs.overlay.classList.add('opacity-0');
    this.$refs.panel.classList.remove('pointer-events-none');
    this.$refs.panel.classList.add('translate-x-full');
    this.$el.classList.add('pointer-events-none');

    setTimeout(() => {
      this.header.classList.add('z-40');
      this.header.classList.remove('z-10');
      this.$el.classList.add('hidden');
      this.mainAddToCartForm = document.querySelector('#main-add-to-cart form');

      if (this.fromAddToCart && this.mainAddToCartForm && anyChecked) {
        this.mainAddToCartForm.requestSubmit();
        this.fromAddToCart = false;
      }
    }, 400);
  }
}
